import { verify, formatString } from '../../utils'

// 表单验证
// data：表单数据
// rules：验证规则，每一个key包含一组规则，按规则顺序验证，只报一个msg
// {
//   key: [
//     { required: true, message: '提醒信息' },
//     { number: true, message: '提醒信息' },
//     { email: true, message: '提醒信息' }
//   ],
//   key2: [
//     { number: true, message: '提醒信息' }
//   ],
//   key3: [
//     { email: true, message: '提醒信息' }
//   ]
// }
// result：验证结果，只包含未通过验证的信息
// {
//   key1: message,
//   key2: message
// }
const formValid = function(data, rules) {
  let result = {}
  for (let key in rules) {
    for (var i = 0; i < rules[key].length; i++) {
      let rule = rules[key][i]

      if (rule.required) {
        // 不能为空
        if (data[key] == null || data[key] === '') {
          result[key] = rule.message
          break
        }
      }
      if (rule.maxLength) {
        // 最大长度
        if (data[key] != null && data[key].toString().length > rule.maxLength) {
          result[key] = formatString(rule.message, [rule.maxLength])
          break
        }
      }
      if (rule.minLength) {
        // 最小长度
        if (data[key] != null && data[key].toString().length < rule.minLength) {
          result[key] = formatString(rule.message, [rule.minLength])
          break
        }
      }
      if (rule.min) {
        // 最小值（不包含）
        if (data[key] != null && data[key] <= rule.value) {
          result[key] = formatString(rule.message, [rule.min])
          break
        }
      }
      if (rule.max) {
        // 最大值（不包含）
        if (data[key] != null && data[key] >= rule.value) {
          result[key] = formatString(rule.message, [rule.max])
          break
        }
      }
      if (rule.mobile) {
        // 手机
        if (data[key] != null && !verify.verify(data[key], 'mobile')) {
          result[key] = rule.message
          break
        }
      }
      if (rule.email) {
        // 邮箱
        if (data[key] != null && verify.verify(data[key], 'email')) {
          result[key] = rule.message
          break
        }
      }
      // TODO其他规则待添加
      // 数字
      // 纯数字
      // 26字母
      // 26字母+数字
      // 自定义规则
    }
  }

  if (JSON.stringify(result) !== '{}') {
    return result
  } else {
    return null
  }
}

export {
  formValid
}



// WEBPACK FOOTER //
// ./src/commons/components/openShop/method.js